// extracted by mini-css-extract-plugin
export default {"container":"power_container__7QuvC","active":"power_active__HzP0c","control":"power_control__iCUub","icon":"power_icon__2k0lD"};